import React from 'react';
import { Container } from 'react-bootstrap';
import { goalTypeToUrl } from '../utils/goalTypeUtils';
import HomeHero from './HomeHero';
import FrameworkSwitcher from './FrameworkSwitcher';
import HomeExplorePanel from './HomeExplorePanel';
import ProfileDownloadBar from './ProfileDownloadBar';
import HomeIndicatorsList from './HomeIndicatorsList';
import GoalTile from './GoalTile';
import '../utils/sharedStyles.css';

const GoalGridDesktop = ({
  goals,
  goalType,
  indicators,
  indicatorsLoading,
  title,
  subtitle,
  reportDownloadTitle,
  homeCopy = {},
  handleGoalClick,
  handleIndicatorClick,
}) => {
  const copy = {
    legendHeading: goalType !== 'un' ? 'SDG Progress & Status Assessment' : 'SDG Progress',
    statusAssessmentBlurb:
      'STATUS: Where Kosovo sits among EU-27 comparison countries (benchmark quintiles)',
    progressBlurb: 'PROGRESS: Direction and pace of progress toward each SDG target',
    goalCardIndicatorsTitle: 'View All Indicators',
    goalCardIndicatorsSubtitle: 'View all indicators for this goal',
    goalCardTargetsTitle: 'Indicators grouped by Targets',
    indicatorsSectionTitle: goalType === 'eu' ? 'EU SDG Indicators' : 'UN SDG Indicators',
    indicatorsSectionSubtitle: 'Click the indicator to view the latest data',
    viewAllIndicatorsLink: 'View all indicators (including those without data yet)',
    noIndicatorsMessage: `No indicators available for ${goalType === 'eu' ? 'EU' : 'UN'} SDGs`,
    reportDownloadLabel: reportDownloadTitle,
    ...homeCopy,
  };

  const downloadLabel =
    copy.reportDownloadLabel ||
    reportDownloadTitle ||
    (goalType === 'eu'
      ? 'Download Kosovo EU SDG Profile (PDF)'
      : 'Download Kosovo SDG Profile (PDF)');

  return (
    <div className="desktop-only home-redesign">
      <HomeHero title={title} subtitle={subtitle} />
      <Container>
        <FrameworkSwitcher copy={copy} />

        <HomeExplorePanel goalType={goalType} copy={copy}>
          <div className="goal-grid">
            {goals.length === 0 && (
              <div style={{ padding: '20px', textAlign: 'center' }}>No goals found.</div>
            )}
            {goals.map((goal) => (
              <GoalTile
                key={goal.id}
                goal={goal}
                goalType={goalType}
                copy={copy}
                onSelect={handleGoalClick}
              />
            ))}
          </div>
        </HomeExplorePanel>

        <ProfileDownloadBar
          to={`/${goalTypeToUrl(goalType)}/sdg-profile`}
          label={downloadLabel}
        />

        <hr className="home-section-divider" />

        <HomeIndicatorsList
          goals={goals}
          goalType={goalType}
          indicators={indicators}
          indicatorsLoading={indicatorsLoading}
          copy={copy}
          handleIndicatorClick={handleIndicatorClick}
          variant="desktop"
        />
      </Container>
    </div>
  );
};

export default GoalGridDesktop;
